import { useState } from "react"

const AskQuestionModal = ({ show, onHide, onSubmit }) => {
  const [questionText, setQuestionText] = useState("")
  const [category, setCategory] = useState("General")
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState(null)

  const categories = [
    "General"
  ]

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!questionText.trim()) return

    setSubmitting(true)
    setError(null)

    try {
      // Call the parent component's onSubmit function which handles the API call
      const result = await onSubmit({
        questionText: questionText.trim(),
        category,
      })

      // Check if there was an error returned
      if (result && result.error) {
        setError(result.error)
        setSubmitting(false)
        return
      }

      // Reset form on success
      setQuestionText("")
      setCategory("General")
    } catch (err) {
      setError("Failed to submit question. Please try again.")
      //console.error("Error in question submission:", err)
    } finally {
      setSubmitting(false)
    }
  }

  const handleClose = () => {
    if (!submitting) {
      setQuestionText("")
      setCategory("General")
      setError(null)
      onHide()
    }
  }

  if (!show) return null

  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <i className="fas fa-question-circle text-primary me-2"></i>
              Ask a New Question
            </h5>
            <button type="button" className="btn-close" onClick={handleClose} disabled={submitting}></button>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              {error && (
                <div className="alert alert-danger" role="alert">
                  <i className="fas fa-exclamation-circle me-2"></i>
                  {error}
                </div>
              )}

              <div className="mb-3">
                <label htmlFor="category" className="form-label">
                  Category <span className="text-danger">*</span>
                </label>
                <select
                  id="category"
                  className="form-select"
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  required
                  disabled={submitting}
                >
                  {categories.map((cat) => (
                    <option key={cat} value={cat}>
                      {cat}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <label htmlFor="questionText" className="form-label">
                  Your Question <span className="text-danger">*</span>
                </label>
                <textarea
                  id="questionText"
                  className="form-control"
                  rows={4}
                  value={questionText}
                  onChange={(e) => setQuestionText(e.target.value)}
                  placeholder="Please describe your question in detail..."
                  required
                  maxLength={1000}
                  disabled={submitting}
                />
                <div className="form-text">{questionText.length}/1000 characters</div>
              </div>

              <div className="alert alert-info">
                <i className="fas fa-info-circle me-2"></i>
                <strong>Tips for better answers:</strong>
                <ul className="mb-0 mt-2">
                  <li>Be specific and clear in your question</li>
                  <li>Provide context if relevant to your course or situation</li>
                  <li>Check if your question has been asked before</li>
                </ul>
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={handleClose} disabled={submitting}>
                Cancel
              </button>
              <button type="submit" className="btn btn-primary" disabled={submitting || !questionText.trim()}>
                {submitting ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                    Submitting...
                  </>
                ) : (
                  <>
                    <i className="fas fa-paper-plane me-2"></i>
                    Submit Question
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default AskQuestionModal
